<template>
  <div class="flex flex-col gap-2">
    <div v-for="(item, index) in inputs" :key="'input-' + index" class="flex items-center gap-1.5">
      <ui-input
        :model-value="inputs[index]"
        :placeholder="placeholder"
        @update:model-value="(value) => updateInput(index, value)"
      />
      <ui-button
        v-if="inputs.length > 1"
        variant="ghost"
        size="icon"
        :aria-label="tr('Remove')"
        @click="() => removeInput(index)"
      >
        <trash-2-icon />
      </ui-button>
    </div>
    <ui-button variant="outline" class="w-fit" @click="() => addInput()">
      <plus-icon />
      {{ addButtonLabel }}
    </ui-button>
  </div>
</template>

<script>
import { Plus, Trash2 } from '@lucide/vue';

export default {
  name: 'MultiTextInput',
  components: {
    PlusIcon: Plus,
    Trash2Icon: Trash2,
  },
  props: {
    modelValue: {
      type: Array,
      required: false,
      default: () => [],
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    addButtonLabel: {
      type: String,
      required: false,
      default: '',
    },
    validationRule: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data: () => ({
    inputs: [ '' ],
  }),
  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        const arr = Array.isArray(newVal) ? [ ...newVal ] : [];
        const currentNonEmpty = this.inputs
          .filter(v => v && String(v).trim())
          .map(v => String(v).trim());

        if (JSON.stringify(arr) === JSON.stringify(currentNonEmpty)) {
          return;
        }

        this.inputs = arr.length > 0 ? [ ...arr ] : [ '' ];
      },
    },
  },
  methods: {
    updateInput(index, value) {
      this.inputs[index] = value;
      this.emitValue();
    },
    emitValue() {
      const nonEmpty = this.inputs
        .filter(v => v && String(v).trim())
        .map(v => String(v).trim());
      this.$emit('update:modelValue', nonEmpty);
    },
    addInput() {
      this.inputs.push('');
    },
    removeInput(index) {
      this.inputs.splice(index, 1);
      if (this.inputs.length === 0) {
        this.inputs.push('');
      }
      this.emitValue();
    },
    validate() {
      if (!this.validationRule) {
        return true;
      }

      const nonEmpty = this.inputs
        .filter(v => v && String(v).trim())
        .map(v => String(v).trim());

      for (const val of nonEmpty) {
        if (!this.validationRule(val)) {
          return false;
        }
      }

      return true;
    },
  },
};
</script>
